<template>
  <div>
    <div
      class="hearder-warpper"
      :class="{
        isFixed,
        isHyaline,
        boxShadow: opcatiy > 0.5,
        isMobile,
        isWhite,
        isPopShow: popShow,
      }"
      :style="`${
        isFixed && isHyaline ? `background:rgba(255,255,255,${opcatiy})` : ''
      }`"
    >
      <div
        class="page-width-warpper hearder-content"
        :style="{ height: headerHeight }"
      >
        <div class="logo">华武电工</div>
        <template v-if="!isMobile">
          <ul>
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="{ active: currentIndex === index }"
              @click="navSelect(item)"
            >
              {{ item.name }}
              <template v-if="item.children">
                <div class="children">
                  <p
                    :class="
                      currentIndex === index && childrenIndex === index2
                        ? 'on'
                        : ''
                    "
                    v-for="(arr, index2) in item.children"
                    :key="index2"
                    @click.stop="$router.push(arr.to)"
                  >
                    <span> {{ arr.label }}</span>
                  </p>
                </div>
              </template>
            </li>
          </ul>
          <!-- <div class="btns">
            <el-button plain>登录</el-button>
          </div> -->
        </template>
        <div v-else>
          <i
            :class="`${popShow ? 'el-icon-close' : 'el-icon-s-unfold'}`"
            :style="{
              fontSize: '30px',
              color: popShow ? '#333' : isWhite ? '#fff' : '#333',
            }"
            @click="popShow = !popShow"
          ></i>
        </div>
      </div>
    </div>
    <div class="pop" v-show="popShow" :style="{ top: headerHeight }">
      <ul>
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="{ active: currentIndex === index }"
          @click="navSelect(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div
      class="hearder-height"
      v-show="isFixed && !isHyaline"
      :style="{ height: headerHeight }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
    // 初始透明背景
    isHyaline: {
      type: Boolean,
      default: false,
    },
    hyalineHeight: {
      type: Number,
      default: 140,
    },
    // 渐变距离
    scrollHeight: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      isHome: false,
      opcatiy: 0,
      popShow: false,
      navList: [
        { name: "首页", to: "/" },
        { name: "走进华武", to: "/about" },
        { name: "产品中心", to: "/product" },
        { name: "企业动态", to: "/news" },
        { name: "客户服务", to: "/system" },
        { name: "联系我们", to: "/contactUs" },
        // {
        //   name: "帮助中心",
        //   type: "link",
        //   flag: true,
        //   children: [
        //     // { to: "/front-bear", label: "行业智库" },
        //     { to: "/about", label: "关于我们" },
        //     { to: "/front-help", label: "帮助中心" },
        //   ],
        // },
      ],
      currentIndex: 0,
      childrenIndex: 0,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.isHome = val.fullPath === "/";
        let findIndex = -1;
        // console.log(this.navList)
        this.navList.some((item, index) => {
          if (
            (item.to && item.to === val.path) ||
            (item.children &&
              item.children.findIndex((f) => f.to === val.path) !== -1)
          ) {
            // if (val.fullPath === item.to) {
            findIndex = index;
            return true;
          }
        });
        // console.log(findIndex)
        this.currentIndex = findIndex;
        if (
          this.currentIndex !== -1 &&
          this.navList[this.currentIndex].children
        ) {
          this.childrenIndex = 0;
          if (val.query.code) {
            this.navList[this.currentIndex].children.some((item, index) => {
              if (item.code === val.query.code) {
                this.childrenIndex = index;
                return true;
              }
            });
          }
        } else {
          this.currentIndex = findIndex;
        }
        // if (this.currentIndex == 0) {
        //   this.currentIndex = 4
        // }
      },
    },
  },
  computed: {
    isWhite() {
      return this.isHome && this.opcatiy < 0.5;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    headerHeight() {
      return !this.$store.state.isMobile ? "97px" : "64px";
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 处理滚动事件的逻辑
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= this.hyalineHeight) {
        if (scrollTop >= this.hyalineHeight + this.scrollHeight) {
          this.opcatiy = 1;
          return;
        }
        this.opcatiy = (scrollTop - this.hyalineHeight) / this.scrollHeight;
      } else {
        this.opcatiy = 0;
      }
    },
    navSelect(item) {
      this.popShow = false;
      if (item.break) {
        window.open(`${window.location.origin}${item.to}`, "_blank");
      } else if (item.children && item.type === "code") {
        this.$router.push({
          path: item.to,
          query: { code: item.children[0].code },
        });
      } else if (item.children && item.type === "link") {
        this.$router.push(item.children[0].to);
      } else {
        this.$router.push({ path: item.to });
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css

.pop {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1111;
  background: rgba($color: #fff, $alpha: 1);
  ul {
    padding: 0 12px;
    li {
      border-bottom: 1px solid #ddd;
      line-height: 3;
      font-size: 18px;
      color: #333;
      text-align: center;
      font-weight: bold;
      cursor: pointer;
      &.active {
        color: $main-color;
      }
      &:hover {
        color: $main-color;
        text-decoration: underline;
      }
    }
  }
}
.hearder-warpper {
  background: #fff;
  box-sizing: border-box;
  color: #333;
  &.isFixed {
    position: fixed;
    z-index: 1111;
    top: 0;
    left: 0;
    right: 0;
  }
  &.isHyaline {
    background: none;
  }
  &.boxShadow {
    box-shadow: $box-shadow;
  }
  &.isMobile {
    .hearder-content {
      .logo {
        font-size: 24px;
      }
    }
  }
  &.isWhite {
    color: #fff;
    .btns {
      .el-button {
        &:nth-child(1),
        &:nth-child(2) {
          border-color: #fff !important;
          color: #fff !important;
        }
        &:nth-child(3) {
          background: #fff !important;
          color: $main-color;
        }
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  &.isPopShow {
    color: #333;
    background: #fff !important;
  }
  .hearder-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      font-size: 42px;
      font-weight: bold;
    }
    .btns {
      .el-button {
        height: 34px;
        padding: 6px 24px;
        border-radius: 10px;
        &:nth-child(1),
        &:nth-child(2) {
          background: none;
          border-color: #666;
          &:hover {
            border-color: $main-color;
          }
        }
      }
    }
    ul {
      // flex: 1;
      display: flex;
      margin-left: 80px;
      li {
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        position: relative;
        margin-right: 60px;
        &:last-child {
          margin-right: 0;
        }
        &::after {
          content: "";
          position: absolute;
          bottom: 8px;
          height: 2px;
          background: $main-color;
          width: 0;
          left: 50%;
          transform: translateX(-50%);
        }
        &:hover {
          color: $main-color;
          .children {
            display: block;
          }
          &::after {
            transition: 0.5s width;
            width: 100%;
          }
        }
        &.active {
          // background: $main-color;
          color: $main-color;
          &::after {
            width: 100%;
          }
        }
        .children {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          // min-width: 90px;
          // text-align: center;
          display: none;
          text-align: center;
          background: #fff;
          z-index: 10;
          border-radius: 4px;
          overflow: hidden;
          padding: 5px 15px;
          opacity: 0.9;
          box-shadow: $box-shadow;
          p {
            line-height: 1.5;
            font-size: 14px;
            color: #333;
            cursor: pointer;
            padding: 5px 0;
            white-space: nowrap;
            // border-bottom: 1px solid #efefef;
            // &:last-child {
            //   border: none;
            // }
            &.on {
              color: $main-color;
            }
            &:hover {
              color: $main-color;
            }
          }
        }
      }
    }
  }
}
</style>
